import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getCustomerGeneralSettings,
  getCustomerNotificationSettings,
  updateCustomerGeneralSettings,
  updateCustomerNotificationSettings,
} from "controller/api";
import { UpdpateCustomerGeneralSettingsInput } from "shared";

export const useGetCustomerGeneralSettings = (customerId: string) => {
  return useQuery({
    queryKey: ["customer_general_settings", customerId],
    queryFn: () => getCustomerGeneralSettings(customerId),
    onError: (error) => console.log(error),
  });
};

export const useUpdateCustomerGeneralSettings = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({
      bodyData,
      customerId,
    }: {
      bodyData: UpdpateCustomerGeneralSettingsInput;
      customerId: string | undefined;
    }) => updateCustomerGeneralSettings({ customerId, bodyData }),
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries([
          "customer_general_settings",
          variables.customerId,
        ]);
      },
    }
  );
};
